<template>
  <div
    v-if="corporateClient == 'hoval'"
    class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5"
  >
    <loading v-if="loadingState" />
    <Hoval />
  </div>
  <div
    v-else-if="corporateClient == 'emicon'"
    class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5"
  >
    <loading v-if="loadingState" />
    <Emicon />
  </div>
</template>

<script>
import { USER_REQUEST } from "actions/user";

import { AUTH_REQUEST, AUTH_SOCIAL, SET_USER_TOKEN } from "actions/auth";
import { mapGetters, mapState } from "vuex";
import { ADD_NOTIFICATIONS, GET_NOTIFICATIONS } from "actions/notifications";

import axios from "axios";
import Hoval from "./hoval.vue";
import Emicon from "./emicon.vue";
const moment = require("moment");

export default {
  name: "acceptInvoice",
  components: {
    Emicon,
    Hoval,
  },
  data() {
    return {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      moment: require("moment"),
      item: {},
      hideData: false,
      email: "",
      codice_fiscale: "",
      partita_iva: "",
      phone: "",
      mobile: "",
      cellulare: "",
      numero_ordine: "",
      citySE: "",
      capSE: "",

      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      client_ownership: "",
      subalterno: "",
      particella: "",
      foglio: "",
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      userForLog: {},
      corporateClient: "",
    };
  },
  methods: {
    setProfile: function () {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
    },
  },
  watch: {
    getProfile() {
      this.setProfile();
    },
  },
  created() {},
  async mounted() {
    this.$log(this.$route);
    this.setProfile();
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "loginerror",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
    ]),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),
  },
};
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
  position: absolute;
  bottom: -37px;
  font-size: 17px;
  width: 100%;
  text-align: center;
  color: #0e3d8b !important;
  z-index: 12313;
  white-space: nowrap;
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.borderTop {
  border-top: 3px solid #003d13;
  padding-top: 15px;
}

.shopIcon {
  width: 75px;
}

.bigTitle {
  font-size: 47px;
  color: #003d13;

  @media screen and (max-width: $phone) {
    font-size: 27px;
  }
}

.hideFileUpload {
  position: absolute;
  width: 100%;
  height: 110%;
  background: #000000;
  opacity: 0.4;
  top: -18px;
  left: 0;
  filter: blur(24px);
  z-index: 10000;
}

h5 {
  @media screen and (max-width: $phone) {
    font-size: 14px;
  }
}
.corporateImg {
  max-height: 153px;
}
.backImageInvoice {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  > img {
    max-height: 477px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.zoomImage {
  position: absolute;
  left: 48%;
  top: 230px;
  cursor: pointer;
}

.vcenter {
  align-items: center;
  align-self: center;
  vertical-align: middle;
  display: inherit;
}

.front-image {
  position: relative;
  margin: 0 auto;
  display: block;
  height: 177px;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-item-align: center;
  align-self: center;
  width: 191px;
  margin-bottom: 17px;

  @media screen and (max-width: $tablet) {
    margin-top: 15px !important;
  }

  > .fileInputLabel {
    display: none;
  }

  > .invalid-feedback {
    display: block;
    position: absolute;
    bottom: 15px;
    font-weight: 800;
  }

  > input {
    position: absolute;
    filter: alpha(opacity=0);
    opacity: 0;
    left: 5px;
    width: 100%;
    height: 200px;
    z-index: 10;
    top: -20px;
  }

  > label {
    /*display: none;*/

    width: 100%;
    margin: 0 auto;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    position: relative;
    padding: 0!important !important;
    left: 0;

    > span {
      background-color: transparent;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      width: 192px;
      margin-top: 19px !important;
      display: block;
      height: 155px;
      margin: 0 auto;
      cursor: pointer;
      word-break: break-all;
      padding: 5px;
      color: white;
      border-radius: 7px;
      overflow-wrap: break-word;
      white-space: normal;
      line-height: 29px;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      align-self: center;
      vertical-align: middle;
      margin: auto;
      display: inline-grid;
      background-size: cover;
      background-position: center;

      &:before {
        content: "+";
        display: block;
        clear: both;
        text-align: center;
        height: 141px;
        width: 179px;
        border-radius: 7px;
        padding-top: 51px;
        font-size: 51px;
        font-weight: 600;
        color: #00917e;
        border: 3px solid #00917e;
      }

      @media screen and (max-width: $phone) {
        margin: 0 auto!important !important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important !important;
        float: none;
      }
    }

    &:after {
      content: "";
      display: block;

      clear: both;
      text-align: center;
      width: 237px;
      font-size: 10px;
      text-decoration: underline;
      color: black;

      /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

      @media screen and (max-width: $phone) {
        margin: 0 auto!important !important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important !important;
        float: none;
      }
    }

    @media screen and (max-width: $phone) {
      width: 100% !important;
      float: none !important;
      text-align: center !important;
      margin: 0 auto!important !important;
    }
    @media screen and (min-width: $phone) and (max-width: $tablet) {
      width: 100% !important;
      float: none !important;
      text-align: center !important;
      margin: 0 auto!important !important;
    }
  }
}

.center-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/acceptInvoice/index.vue